import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBack = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "back",
	"data-name": "back",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 12,
			cy: 12,
			r: 10.5
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "plan2plate-icon",
			points: "9.14 12 15.82 8.18 15.82 15.82 9.14 12"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 8.18,
			y1: 16.77,
			x2: 8.18,
			y2: 7.23
		})
	]
});
const ForwardRef = forwardRef(SvgBack);
export default ForwardRef;
